<template>
  <aside class="help-center-post-aside__component">
    <HelpCenterTableOfContents
      v-if="hasSufficientToC"
      :components="rootComponents"
      :root-fragment="rootFragment"
    />

    <div class="help-center-post-aside__meta">
      <HelpCenterPostAuthor
        v-if="post.author"
        :post="post"
        :author-map="authorMap"
        simplified
      />

      <HelpCenterPostPills
        :post="post"
        :category-map="categoryMap"
      />

      <HelpCenterPostShare
        :type="type"
        :post="post"
      />

      <HelpCenterSupportCard
        v-if="post.support_card"
        :post="post"
      />
    </div>
  </aside>
</template>

<script setup>
import { computed } from 'vue'
import HelpCenterPostPills from 'help-center/components/HelpCenterPostPills'
import HelpCenterPostShare from 'help-center/components/HelpCenterPostShare'
import HelpCenterPostAuthor from 'help-center/components/HelpCenterPostAuthor'
import HelpCenterSupportCard from 'help-center/components/HelpCenterSupportCard'
import HelpCenterTableOfContents from 'help-center/components/HelpCenterTableOfContents'

const props = defineProps({
  type: {
    type: String,
    required: true
  },
  post: {
    type: Object,
    required: true
  },
  authorMap: {
    type: Object,
    required: true
  },
  categoryMap: {
    type: Object,
    required: true
  },
  rootFragment: String
})

const rootComponents = computed(() => {
  return props.post.components.filter((component) => {
    return component.title_level === 1
  })
})

const hasSufficientToC = computed(() => {
  return rootComponents.value.length > 1
})
</script>

<style lang="scss">
.help-center-post-aside {
  &__component {
    gap: 28px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  &__meta {
    gap: 28px;
    display: flex;
    flex-direction: column;
  }
}
</style>
